"use strict";
exports.__esModule = true;
exports.validateIntentName = function (value) {
    if (!/^[a-zA-Z_][0-9a-zA-Z_\.]*$/.test(value)) {
        return "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442";
    }
    return '';
};
